import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useId, useRef, useEffect, Children, isValidElement } from 'react';
const ActionMenu = (props) => {
    var _a, _b;
    const [open, setOpen] = useState(false);
    const [fixedStyle, setFixedStyle] = useState();
    const id = useId();
    const ref = useRef(null);
    const size = props.size || 'md';
    const variant = props.variant || 'secondary';
    const horizontal = props.direction === 'horizontal';
    const buttonClass = `btn btn-${variant} btn-${size} ${(_a = props.triggerClassName) !== null && _a !== void 0 ? _a : ''}`.trim();
    const close = () => setOpen(false);
    const toggle = () => {
        if (!open && props.fixed && ref.current) {
            const rect = ref.current.getBoundingClientRect();
            setFixedStyle({ position: 'fixed', top: rect.top, right: document.documentElement.clientWidth - rect.right });
        }
        setOpen(!open);
    };
    // Close on outside click
    useEffect(() => {
        const handleClick = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClick);
        return () => document.removeEventListener('mousedown', handleClick);
    }, []);
    // A fixed menu would drift away from its trigger on scroll or resize, so close it instead
    useEffect(() => {
        if (!open || !props.fixed)
            return;
        const handleMove = () => setOpen(false);
        window.addEventListener('scroll', handleMove, true);
        window.addEventListener('resize', handleMove);
        return () => {
            window.removeEventListener('scroll', handleMove, true);
            window.removeEventListener('resize', handleMove);
        };
    }, [open, props.fixed]);
    const trigger = props.render ? (_jsx("button", { type: "button", className: `btn btn-light border-0 p-0 ${(_b = props.triggerClassName) !== null && _b !== void 0 ? _b : ''}`.trim(), onClick: toggle, "aria-expanded": open, disabled: props.disabled, id: id, children: props.render })) : props.onClick ? (_jsxs(_Fragment, { children: [_jsx("button", { type: "button", className: buttonClass, onClick: props.onClick, disabled: props.disabled, children: props.label }), _jsx("button", { type: "button", className: `${buttonClass} dropdown-toggle dropdown-toggle-split`, "aria-expanded": open, disabled: props.disabled, onClick: toggle, id: id, children: _jsx("span", { className: "visually-hidden", children: "Toggle dropdown" }) })] })) : (_jsx("button", { type: "button", className: `${buttonClass} dropdown-toggle`, "aria-expanded": open, disabled: props.disabled, onClick: toggle, id: id, children: props.label }));
    return (_jsxs("div", { ref: ref, className: `btn-group ${props.className || ''}`, style: props.style, children: [trigger, open && (horizontal ? (_jsx("div", { className: "dropdown-menu show mt-4 d-flex gap-1 p-1", style: props.fixed ? fixedStyle : undefined, "aria-labelledby": id, onClick: close, children: props.children })) : (_jsx("ul", { className: "dropdown-menu show mt-4", style: props.fixed ? fixedStyle : undefined, "aria-labelledby": id, onClick: close, children: Children.map(props.children, (child, i) => isValidElement(child) ? _jsx("li", { children: child }, i) : null) })))] }));
};
const ActionMenuItem = (props) => (_jsx("button", { type: "button", className: `dropdown-item${props.disabled ? ' disabled' : ''}`, onClick: props.onClick, disabled: props.disabled, children: props.children }));
ActionMenu.Item = ActionMenuItem;
export default ActionMenu;
